<template>
    <section class="hero-section text-light text-center py-5">
        <h1 v-html="t('heroTitle')" class="display-4 font-weight-bold mb-3 mt-5 font-Montserrat noselect"></h1>
    
        <p v-html="t('subHero')" class="custom-20px-500 text-white font-inter"></p>
    
    
        <div class="text-center">
            <a
  href="https://wa.me/601135546900?text=Saya%20ingin%20tanya%20berkaitan%20kelas%20di%20FlyHigh"
  target="_blank"
  rel="noopener noreferrer"
>
            <CButton type="button" class="custom-white-badge custom-16px-600">
                {{ t('startNow') }}
            </CButton>
            </a>
        </div>
        <div class="hero-image mt-4 p-3" style="width:85%;margin:0 auto">
            <img src="@/assets/img/bannerlandingpage.jpg" alt="FlyHigh Ambassador Banner" class="img-fluid rounded" />
        </div>
    </section>
</template>

<script>
import { translations } from '@/bm.js'
import { langState } from '@/main.js'

export default {
    methods: {
    t(key) {
      return translations[langState.currentLang][key] || ''
    }
  }
}
</script>

<style scoped>
.hero-section {
    background-color: #0A1129;
    /* dark navy background */
}

.text-highlight {
    color: #84bfff;
    /* light blue highlight */
}

.hero-image img {
    max-width: 100%;
    height: auto;
    border-radius: 1rem;
}

.font-weight-bold {
    text-align: center;
    font-family: Montserrat;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -2.56px;
}
</style>